import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MappingService } from "src/core/services/mapping.service";
import { MappingFilter } from "../../../../../api/models/mapping-filter";
import { InsiderMappingService } from "../../../../../api/services/insider-mapping.service";
import { ConfirmationService, MessageService } from "primeng/api";
import RemoveAsReportedInsiderParams = InsiderMappingService.RemoveAsReportedInsiderParams;
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-insider-unreferenced",
  // imports: [],
  templateUrl: "./unreferenced.component.html",
  styleUrl: "./unreferenced.component.css",
  standalone: false,
})
export class InsiderUnreferencedComponent implements OnInit, OnChanges {
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  unReferencedInsiders: any[] = [];
  selectedInsiders: any[] = [];
  selectedDialogRow: any = null;

  // Pagination for Issuers
  issuerFirst = 0;
  issuerRows = 10;
  insiderName?: string;
  issuerName?: string;
  isLoading: boolean = false;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  First = 0;
  Rows = 10;
  constructor(
    public confirmationService: ConfirmationService,
    public dialogService: DialogService,
    public insiderService: InsiderMappingService,
    public _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  getUnreferencedInsiders() {
    const params: MappingFilter = {
      searchByName: this.issuerName,
      searchByInsiderName: this.insiderName,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "UNREFERENCED",
    };
    this.isLoading = true;
    this.insiderService.getInsiderMapping(params).subscribe({
      next: (value) => {
        this.unReferencedInsiders = value.UnReferencedInsider ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unReferencedInsiders?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }

  onDeleteClick(product: any) {
    this.confirmationService.confirm({
      message: "Are you sure you want to un-reference this insider?",
      header: "Confirm Un-Reference",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const params: RemoveAsReportedInsiderParams = {
          asReportedInsiderId: product.asReportedInsiderId,
          reason: "Deleted as reported successfully",
        };
        this.isLoading = true;
        this.insiderService.removeAsReportedInsider(params).subscribe({
          next: (value) => {
            this.getUnreferencedInsiders();
            // handle success if needed
          },
          error: (err) => {
            this.isLoading = false;
            this._messageService.add({
              summary: err.error?.message || "Error occurred",
              severity: "error",
            });
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },
    });
  }

  pageChange(event: any) {
    this.First = event.first;
    this.Rows = event.rows;
  }
  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.First = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.First = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getUnreferencedInsiders();
  }

  onSearch() {
    // Trim string search fields before building params
    this.issuerName = this.issuerName?.trim() || undefined;
    this.insiderName = this.insiderName?.trim() || undefined;

    this.First = 0;
    this.paginator.pageNumber = 1;
    this.getUnreferencedInsiders();
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(event: ClipboardEvent, field: "issuerName" | "insiderName"): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
